import { useState } from "react";
import { useUiText } from "../i18n/useUiText";
import { Button } from "./Button";
import { HelpIcon } from "./Icons";
import { Modal } from "./Modal";

function utcBuildTime(isoTimestamp: string): string {
  return isoTimestamp.replace("T", " ").replace(/\.\d{3}Z$/u, " UTC");
}

export function HelpButton() {
  const t = useUiText();
  const [open, setOpen] = useState(false);
  const shortCommit =
    __APP_RELEASE__.commitSha === "local"
      ? __APP_RELEASE__.commitSha
      : __APP_RELEASE__.commitSha.slice(0, 12);

  return (
    <>
      <Button
        aria-label={t("help.open")}
        className="icon-only-button"
        onClick={() => setOpen(true)}
        variant="ghost"
      >
        <HelpIcon />
      </Button>
      <Modal
        closeLabel={t("common.close")}
        footer={
          <Button onClick={() => setOpen(false)} wide>
            {t("common.close")}
          </Button>
        }
        onClose={() => setOpen(false)}
        open={open}
        title={t("help.title")}
      >
        <div className="info-modal">
          <p>{t("help.intro")}</p>
          <h3>{t("help.offlineTitle")}</h3>
          <p>{t("help.offlineBody")}</p>
          <h3>{t("help.privacyTitle")}</h3>
          <p>{t("help.privacyBody")}</p>
          <h3>{t("help.releaseTitle")}</h3>
          <dl className="release-info">
            <dt>{t("help.versionLabel")}</dt>
            <dd>v{__APP_RELEASE__.version}</dd>
            <dt>{t("help.revisionLabel")}</dt>
            <dd>
              <code>{shortCommit}</code>
            </dd>
            <dt>{t("help.buildTimeLabel")}</dt>
            <dd>
              <time dateTime={__APP_RELEASE__.builtAt}>
                {utcBuildTime(__APP_RELEASE__.builtAt)}
              </time>
            </dd>
            <dt>{t("help.buildPlatformLabel")}</dt>
            <dd>{__APP_RELEASE__.platform}</dd>
          </dl>
        </div>
      </Modal>
    </>
  );
}
